import { useMutation, useQueryClient } from "react-query";
import { AuthContext } from "../../Context/AuthContext";
import { useContext } from "react";

const deleteProductCategory = async (categoryId, token) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/productcategory/delete/product/category/${categoryId}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to delete category");
  }

  return response.json();
};

const useDeleteProductCategory = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  return useMutation((categoryId) => deleteProductCategory(categoryId, token), {
    onSuccess: () => {
      queryClient.invalidateQueries("productCatories");
    },
  });
};

export default useDeleteProductCategory;
